/*=============================================== NavBottom styles ===============================================*/

import styled from "styled-components/macro"
import { Breakpoints } from "tsx-library-julseb"

export const StyledNavBottom = styled.div`
    width: 100%;
    max-width: 800px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media ${Breakpoints.Tablet} {
        width: 90%;
    }
`
